export default "__VITE_ASSET__cfd30851__"